import React, { Fragment } from 'react';
import { Check } from 'lucide-react';
interface Step {
  id: number;
  label: string;
  description?: string;
}
interface StepIndicatorProps {
  steps: Step[];
  currentStep: number;
}
export function StepIndicator({
  steps,
  currentStep
}: StepIndicatorProps) {
  return <div className="w-full py-6" data-id="element-52">
      <div className="flex items-center justify-center" data-id="element-53">
        {steps.map((step, index) => {
        const isCompleted = currentStep > step.id;
        const isCurrent = currentStep === step.id;
        const isLast = index === steps.length - 1;
        return <Fragment key={step.id} data-id="element-54">
              {/* Step Circle */}
              <div className="relative flex flex-col items-center group" data-id="element-55">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center border-2 transition-all duration-300 z-10
                    ${isCompleted ? 'bg-indigo-600 border-indigo-600 text-white' : isCurrent ? 'bg-white border-indigo-600 text-indigo-600 shadow-md scale-110' : 'bg-white border-gray-300 text-gray-400'}
                  `} data-id="element-56">
                  {isCompleted ? <Check className="w-6 h-6" data-id="element-57" /> : <span className="font-bold" data-id="element-58">{step.id}</span>}
                </div>

                {/* Label */}
                <div className="absolute top-12 w-32 text-center" data-id="element-59">
                  <p className={`text-sm font-medium ${isCurrent ? 'text-indigo-600' : 'text-gray-500'}`} data-id="element-60">
                    {step.label}
                  </p>
                </div>
              </div>

              {/* Connector Line */}
              {!isLast && <div className={`flex-1 h-0.5 mx-4 transition-colors duration-300 ${isCompleted ? 'bg-indigo-600' : 'bg-gray-200'}`} style={{
            minWidth: '3rem'
          }} data-id="element-61" />}
            </Fragment>;
      })}
      </div>
    </div>;
}